import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import BaseService from '../../BaseService'
import Navigation from '../Navigation/Navigation'
import BerechtigteListService from '../../services/BerechtigteListService'
import GPService from './GPService'
import GPDto from './GPDto'
import GPColumns from './GPColumns'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/MultiselectFilter.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter'

export default class Geschaeftspartner extends WebComponent {

  constructor() {
    super()
    this.gpService = new GPService()
    this.kantonService = new BaseService('kanton')
  }

  get translationFile() {
    return './views/Geschaeftspartner/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.kantonService.list(),
      this.gpService.getBackendListUrl()
    ]).then(([kantone, url]) => {
      this.url = url
      this.kantone = kantone.map(kanton => ({value: kanton, name: kanton}))
    }).catch(_ => {
      this.url = ''
      this.kantone = []
    }).finally(() =>
      this.render()
    )
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('gp.uebersicht.title')}">
        ${this._renderGpImport()}
      </isceco-title>
      <isceco-filter-group>
        <isceco-string-filter key="name"
                              label="${this.i18n.translate('gp.table.header.name')}"
        ></isceco-string-filter>
        <isceco-string-filter key="adresse"
                              label="${this.i18n.translate('gp.table.header.adresse')}"
        ></isceco-string-filter>
        <isceco-multiselect-filter key="kanton"
                                   label="${this.i18n.translate('gp.table.header.kanton')}"
                                   .items="${this.kantone}"
        ></isceco-multiselect-filter>
        ${this._renderVnbFilter()}
      </isceco-filter-group>
      <isceco-list url="${this.url}"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toDTO}"
                   .columns="${GPColumns.getColumns()}"
                   .rowurl="${this.toDetailUrl}"
                   sort="name" order="asc"
      ></isceco-list>
    `
  }

  _renderVnbFilter() {
    const roles = new AuthorizationFilter().roles
    if (roles.BWL || roles.OSTRAL) {
      return html`
        <isceco-string-filter key="vnb"
                              label="${this.i18n.translate('gp.table.header.vnb')}"
        ></isceco-string-filter>
      `
    } else {
      return html``
    }
  }

  _renderGpImport = () => {
    const roles = new AuthorizationFilter().roles
    if (roles.VNB) {
      return html`
        <isceco-button text="${this.i18n.translate('gp.table.action.import')}"
                       icon="file import"
                       variant="primary" size="small"
                       @click="${() => navigate({to: Navigation.ROUTES.gpImport.url, allow: true})}"
        ></isceco-button>
      `
    } else {
      return html``
    }
  }

  toDTO = row => new GPDto(row)
  toDetailUrl = row => constructURL({to: Navigation.ROUTES.gpStammdaten.url, id: row.extId})
}

customElements.define('eko-frontend-geschaeftspartner', Geschaeftspartner)
